<template>
    <div class="wrap">
        <div class="container container_top">
            <h3 class="pay_titile" style="display:none;">邮寄地址</h3>
            <div class="adddz" v-if="address_list.length <= 0" style="display:none;" >

            </div>
            <h3 class="pay_titile">付款方式</h3>
            <div class="pay_mode">
                <van-radio-group v-model="radio1">
                    <van-radio name="2" checked-color="#000000" @click="chooespay">
                        <van-row type="flex" align="center">
                            <van-image
                                    height="20"
                                    lazy-load
                                    src="https://www.jqxtech.com/images/alipay.png"
                            />
                            
                        </van-row>
                    </van-radio>
                    <br/>
                    <van-radio name="1" checked-color="#000000" @click="chooespay">
                        <van-row type="flex" align="center">
                            <van-image
                                    height="20"
                                    lazy-load
                                    src="https://www.jqxtech.com/images/wechat.png"
                            />
                            
                        </van-row>
                    </van-radio>
                </van-radio-group>
                  <!-- <div class="adddz" v-if="pay_email_phone">
                    <form >
                        <div class="address_require">
                            <label style="color:red;">请确认您的联系方式，以确保我们能够及时联系: </label>
                            <label>
                                邮箱
                                <span>*</span>
                            </label>
                            <input type="email" maxlength="50" value v-model="email" required/>
                        </div>
                        <div class="address_require">
                            <label>
                                    手机号码
                                    <span>*</span>
                                </label>
                                <input type="text" value v-model="tel"/>
                        </div>
                    </form>
            </div> -->

            </div>






            <router-link
                    class="ress_tz"
                    :to="{path:'selectaddress',query:{id:base.address.id}}"
                    v-if="address_list.length > 0 ? true : false"
            >
                <van-row class="pay_reasss" type="flex" align="center" justify="space-between">
                    <van-col>
                        <van-icon name="location-o"/>
                    </van-col>
                    <van-col>
                        <div class="name">
                            <span>{{ base.address.name }}</span>
                            T:{{ base.address.tel }}
                        </div>
                        <div>
                            {{ base.address.address }} {{ base.address.address_line2 }} {{ base.address.city_name }}
                            {{ base.address.province_name }}
                            {{ base.address.email }}
                        </div>
                    </van-col>
                    <van-col>
                        <van-icon name="arrow"/>
                    </van-col>
                </van-row>
            </router-link>
            <div class="carts pay" style="border-top: 8px solid #f3f3f3;">
                <h3 class="pay_titile">商品明细</h3>
                <van-card
                        v-for="(value,index) in goods_list"
                        :key="index"
                        :title="value.title"
                        :thumb-link="'/#/details/'+value.goods_id"
                >
                    <template #thumb>
                        <van-image width="88" height="88" lazy-load :src="value.images"/>
                    </template>
                    <template #tags>
                        <van-row class="goods_specs" type="flex" justify="start">
                            <van-col
                                    v-for="(value1,index1) in value.spec"
                                    :key="index1"
                            >{{ value1.type }}:{{ value1.value }}
                            </van-col>
                        </van-row>
                    </template>
                    <template #price>
                        <van-row type="flex" align="center" justify="space-between">
                            <div class="carts_price">
                                价格:
                                <font>${{ value.total_price }}</font>
                            </div>
                            <div class="pay_sj">
                              数量:
                                <font>{{ value.buy_number }}</font>
                            </div>
                        </van-row>
                    </template>
                </van-card>
            </div>
            <div class="pay_wl">
                <h3 class="pay_titile">邮寄方式</h3>
                <van-radio-group v-model="radio">
                    <van-cell-group>
                        <van-cell
                                :title="'标准配送（3-7个工作日）'"
                                clickable
                                @click="radio = '1'"
                        >
                            <template #label>
                <span
                        style="color: #323233;color: #000000;"
                >                
                <span v-if="money_free_shipping_cost == 0">
                    <s>￥5.99</s> <span style="font-weight: 900;">免费送货</span>
                </span>
                <span v-if="money_free_shipping_cost > 0">
                    ￥{{ Number(shipping_cost).toFixed(2) }}
                </span>                
                <span v-if="(money_free_shipping_cost - shipping_cost) > 0">
                (保存 ￥{{ Number(money_free_shipping_cost - shipping_cost).toFixed(2) }})
                </span>
                </span>
                            </template>
                            <template #right-icon>
                                <van-radio checked-color="#000000" name="1"/>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </div>
            <h3 class="pay_titile">订单汇总</h3>
            <div class="address_order_total">
                <van-row class="total_list" type="flex" align="center" justify="space-between">
                    <van-col>单价:</van-col>
                    <van-col>￥{{ Number(item_subtotal).toFixed(2) }}</van-col>
                </van-row>
                <van-row class="total_list" type="flex" align="center" justify="space-between">
                    <van-col>折扣:</van-col>
                    <van-col>￥{{ Number(coupon_money).toFixed(2) }}</van-col>
                </van-row>
                <van-row class="total_list" type="flex" align="center" justify="space-between">
                    <van-col>运费:</van-col>
                    <van-col>￥{{ Number(shipping_cost).toFixed(2) }}</van-col>
                </van-row>
                <van-row class="total_list" type="flex" align="center" justify="space-between">
                    <van-col>总计:</van-col>
                    <van-col>￥{{ Number(grand_total).toFixed(2) }}</van-col>
                </van-row>
            </div>
            <van-row type="flex" align="center" justify="center">
                <div class="payment_but">
                    <van-button type="primary" block @click="to_payre">继续付款</van-button>
                </div>
            </van-row>
        </div>
    </div>
</template>
<style>
.container_top{margin-top:45px;}
</style>
<script>
export default {
    components: {},
    created() {
        this.order_no = this.$route.query.order_no;
        this.getData();
        // this.user_info = this.getUserInfo();
        // this.email = this.user_info.email;
        // localStorage.setItem(
        //         "pay_path",
        //         "/pay?ids=" + this.ids + "&buy_type=" + this.buy_type
        // );
    },
    data() {
        return {
            coupons: "",
            columns: [],
            showPicker: false,
            radio: "1",
            radio1: "",
            ids: "",
            buy_type: "",
            goods_list: [],
            address_list: [],
            base: [],
            shipping_cost: 0.0,
            grand_total: 0.0,
            coupon_money: 0.0,
            item_subtotal: 0.0,
            money_free_shipping: 0.0,
            money_free_shipping_cost: 0.0,
            coupon_text: "没有可用优惠券",
            coupon_id: 0,
            exchange_code: null,
            address_id: -1,
            goods_id: 0,
            stock: 1,
            spec: "",
            payment_id: 1,
            user_note: "",
            site_model: "",
            user_info: false,

            //地址相关
            showCountryPicker:false,
            countryPicker: [{id:0,name:'请选择'}],
            showStatePicker: false,
            statePicker: [{id:0,name:'请选择'}],
            showCityPicker: false,
            cityPicker: [{id:0,name:'请选择'}],
            countryName: "请选择",
            stateName: "请选择",
            cityName: "请选择",
            country_id:0,
            province_id: 0,
            city_id: 0,
            email: "",
            full_name: "",
            postal_code: "",
            tel: "",
            address_line: "",
            default_index: 0,
            pay_email_phone:false,
            address_just_email_phone:0,


            order_no:"",
        };
    },
    methods: {
        /**
         * 获取页面数据信息
         * @author  Devil
         * @version 1.0.0
         * @date    2020-03-21
         * @desc    description
         */
        getData() {
            var _self = this
            this.POST('api/order/payre',{"order_no":this.order_no},function (ret){
                var data = ret.data;
                if(ret.code === 0){
                    _self.item_subtotal = data.order.buy_number_count;
                    _self.coupon_money = data.order.preferential_price;
                    _self.shipping_cost = data.order.freight;
                    _self.grand_total = data.order.total_price;
                    _self.goods_list = data.items;
                    if(data.order.pay_upon_invoice == 1){
                        _self.radio1 = "2";
                    }else if(data.order.pay_upon_invoice == 0){
                        _self.radio1 = "1";
                        _self.pay_email_phone = true;
                        _self.email = data.address.email;
                        _self.tel = data.address.tel;
                    }

                }
            })
        },
        chooespay(){
            if(this.radio1 == 1){
                this.pay_email_phone = true;
                this.address_just_email_phone = 1;
            }else{
                this.pay_email_phone = false;
                this.address_just_email_phone = 0;
            }
        },
        to_payre(){
            var _this = this;
            var pay_upon_invoice = 0;
            if(this.radio1 == 2){
                pay_upon_invoice = 1;
            }else{                
                if(this.email == ""){
                    this.$toast("请填写电子邮件");
                    return false;
                }
                if(this.tel == ""){
                    this.$toast("请填写电话");
                    return false;
                }
            }
            this.POST('api/order/pay',{"order_no":this.order_no,"pay_upon_invoice":pay_upon_invoice,"email":this.email,"tel":this.tel},function (ret){
                if(ret.code === 0){
                    _this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                    });
                    window.location.href = ret.data.data;
                }
            })
        }
    },
};
</script>